export class Pniot {
     Id :number=0
    MAINID :number
     Remark:string
    CraeteDate :Date
     UpdateDate :Date
}
